<template>
  <v-card>
    <v-card-title>Create tag</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container grid-list-xl fluid>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-text-field
                v-model="tag.name"
                :rules="[v => !!v || 'Name is required']"
                label="Name" 
                required autofocus></v-text-field>
            </v-flex>
            <v-flex xs12 sm12>
              <v-textarea
                v-model="tag.notes"
                rows="2"
                auto-grow
                clearable
              >
                <template v-slot:label>
                  <div>
                    Note <small>(optional)</small>
                  </div>
                </template>
              </v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <loading-state text="" :state="state"></loading-state>
      <v-btn color="blue darken-1" text v-show="!state.isLoading()" @click="$emit('input', false)">Close</v-btn>
      <v-btn :disabled="(!valid) || state.isLoading()" color="success" class="mr-4" @click="validate">Create</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import Utils from "@/utils"
import { DataState } from "@/state"
import { Tag } from "@/models/tag"
export default {
  props: {
    tag: {
      default: ()=>{return Tag.newEmpty()},
      type: Object
    }
  },
  data: () => ({
    state: DataState.newNotInit(),
    valid: true,
    lazy: true,
  }),

  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.saveTag()
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    saveTag () {
      this.valid = false
      this.state.changeToLoading()
      this.tag.create().then((response) => {
        this.state.changeToLoaded()
        this.$refs.form.reset()
        this.$emit('created', response)
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
  },
}
</script>